module.exports = __webpack_public_path__ + "img/alert-triangle.2fc4fe5f.svg";